(function() {
  var CDN = 'https://cdn.shopify.com/s/files/1/1068/4566/7677/files/';
  var EXTS = ['.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG', '.webp', '.WEBP'];

  function buildUrls(namesStr) {
    var names = namesStr.split('|||').map(function(n) { return n.trim(); }).filter(Boolean);

    // deduplicate
    var seen = {};
    var unique = [];
    names.forEach(function(n) {
      if (n && !seen[n]) { seen[n] = true; unique.push(n); }
    });

    var urls = [];
    unique.forEach(function(name) {
      EXTS.forEach(function(ext) {
        // Try as-is (spaces become %20 via encodeURIComponent but CDN may not like that)
        // So also try with spaces replaced by hyphens and underscores
        var variants = [
          name,                                    // Metal Earth
          name.replace(/\s+/g, '-'),               // Metal-Earth
          name.replace(/\s+/g, '_'),               // Metal_Earth
          name.replace(/\s+/g, ''),                // MetalEarth
          name.replace(/[-_\s]+/g, '-'),           // normalise any separator to hyphen
          name.replace(/[-_\s]+/g, ''),            // strip all separators
        ];
        // dedupe variants
        var vSeen = {};
        variants.forEach(function(v) {
          if (v && !vSeen[v]) {
            vSeen[v] = true;
            urls.push(CDN + v + ext);
          }
        });
      });
    });

    return urls;
  }

  function tryLoad(img, urls) {
    if (!urls.length) {
      img.style.display = 'none';
      var fallback = img.nextElementSibling;
      if (fallback) fallback.style.display = 'block';
      return;
    }
    var url = urls.shift();
    var tester = new Image();
    tester.onload = function() {
      img.src = url;
      img.style.display = 'block';
    };
    tester.onerror = function() {
      tryLoad(img, urls);
    };
    tester.src = url;
  }

  function initLogos() {
    var imgs = document.querySelectorAll('img.card-brand-img[data-vendor-names]');
    imgs.forEach(function(img) {
      if (img.dataset.initialized) return;
      img.dataset.initialized = 'true';
      img.style.display = 'none';
      var urls = buildUrls(img.dataset.vendorNames);
      tryLoad(img, urls);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogos);
  } else {
    initLogos();
  }

  document.addEventListener('shopify:section:load', initLogos);
})();
